// ========================================
// SERVICE - About Page
// Gestion du contenu de la page À Propos
// ========================================

import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from './config';

const COLLECTION = 'aboutPage';
const DOC_ID = 'content';

// Structure par défaut
const defaultAboutContent = {
  profile: {
    image: null,
    name: 'Gustave KONATE',
    title: 'Communicant • Écrivain • Leader Associatif'
  },
  bio: '<p>Je suis Gustave KONATE, un passionné de communication et d\'engagement communautaire basé au Burkina Faso. Mon parcours est guidé par une conviction profonde : la communication peut transformer des vies et bâtir des ponts entre les communautés.</p>',
  values: [
    { id: '1', icon: 'heart', title: 'Authenticité', description: 'Être vrai dans chaque interaction', order: 1 },
    { id: '2', icon: 'users', title: 'Solidarité', description: 'Ensemble, nous sommes plus forts', order: 2 },
    { id: '3', icon: 'lightbulb', title: 'Créativité', description: 'Innover pour mieux servir', order: 3 },
    { id: '4', icon: 'target', title: 'Impact', description: 'Chaque action compte', order: 4 }
  ],
  timeline: [
    {
      id: '1',
      year: '2025',
      organization: 'Living Goods Burkina',
      role: 'Chargé de communication',
      description: 'Reportages photos, articles, contenus multimédia',
      order: 1
    },
    {
      id: '2',
      year: '2024',
      organization: 'Amnesty International Burkina',
      role: 'Coordinateur de projets',
      description: 'Coordination des projets de droits humains',
      order: 2
    }
  ],
  skills: [
    { id: '1', name: 'Communication digitale', percentage: 95 },
    { id: '2', name: 'Graphisme', percentage: 85 },
    { id: '3', name: 'Rédaction', percentage: 90 },
    { id: '4', name: 'Coordination de projets', percentage: 80 }
  ],
  contact: {
    email: 'contactgkonate@gmail.com',
    phones: ['+226 70 11 64 34', '+226 76 96 57 05'],
    location: 'Ouagadougou, Burkina Faso'
  },
  cvUrl: null
};

/**
 * Récupérer le contenu de la page À Propos
 */
export const getAboutContent = async () => {
  try {
    const docRef = doc(db, COLLECTION, DOC_ID);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return { success: true, data: { ...defaultAboutContent, ...docSnap.data() } };
    } else {
      await setDoc(docRef, defaultAboutContent);
      return { success: true, data: defaultAboutContent };
    }
  } catch (error) {
    console.error('Erreur getAboutContent:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Mettre à jour le profil
 */
export const updateProfile = async (profileData) => {
  try {
    const docRef = doc(db, COLLECTION, DOC_ID);
    await updateDoc(docRef, {
      profile: profileData,
      updatedAt: new Date()
    });
    return { success: true };
  } catch (error) {
    console.error('Erreur updateProfile:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Mettre à jour la biographie
 */
export const updateBio = async (bio) => {
  try {
    const docRef = doc(db, COLLECTION, DOC_ID);
    await updateDoc(docRef, {
      bio: bio,
      updatedAt: new Date()
    });
    return { success: true };
  } catch (error) {
    console.error('Erreur updateBio:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Mettre à jour les valeurs
 */
export const updateValues = async (values) => {
  try {
    const docRef = doc(db, COLLECTION, DOC_ID);
    await updateDoc(docRef, {
      values: values,
      updatedAt: new Date()
    });
    return { success: true };
  } catch (error) {
    console.error('Erreur updateValues:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Mettre à jour le parcours
 */
export const updateTimeline = async (timeline) => {
  try {
    const docRef = doc(db, COLLECTION, DOC_ID);
    await updateDoc(docRef, {
      timeline: timeline,
      updatedAt: new Date()
    });
    return { success: true };
  } catch (error) {
    console.error('Erreur updateTimeline:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Mettre à jour les compétences
 */
export const updateSkills = async (skills) => {
  try {
    const docRef = doc(db, COLLECTION, DOC_ID);
    await updateDoc(docRef, {
      skills: skills,
      updatedAt: new Date()
    });
    return { success: true };
  } catch (error) {
    console.error('Erreur updateSkills:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Mettre à jour les informations de contact
 */
export const updateContact = async (contact) => {
  try {
    const docRef = doc(db, COLLECTION, DOC_ID);
    await updateDoc(docRef, {
      contact: contact,
      updatedAt: new Date()
    });
    return { success: true };
  } catch (error) {
    console.error('Erreur updateContact:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Mettre à jour l'URL du CV
 */
export const updateCV = async (cvUrl) => {
  try {
    const docRef = doc(db, COLLECTION, DOC_ID);
    await updateDoc(docRef, {
      cvUrl: cvUrl,
      updatedAt: new Date()
    });
    return { success: true };
  } catch (error) {
    console.error('Erreur updateCV:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Mettre à jour tout le contenu
 */
export const updateAboutContent = async (content) => {
  try {
    const docRef = doc(db, COLLECTION, DOC_ID);
    await updateDoc(docRef, {
      ...content,
      updatedAt: new Date()
    });
    return { success: true };
  } catch (error) {
    console.error('Erreur updateAboutContent:', error);
    return { success: false, error: error.message };
  }
};

export default {
  getAboutContent,
  updateProfile,
  updateBio,
  updateValues,
  updateTimeline,
  updateSkills,
  updateContact,
  updateCV,
  updateAboutContent
};